import React, { useState } from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Box, Button, useMediaQuery } from '@mui/material';
import Section from '../../../shared/Section/Section';
import ModalBlock from '../../../shared/ModalBlock/ModalBlock';
import ConsultationModal from '../../../shared/Modals/ConsultationModal';
import PrecourseProgramWeekCard from '../../../shared/PrecourseProgramWeekCard/PrecourseProgramWeekCard';

const formData = {
  message: 'Получить консультацию',
  sentContent: {
    title: 'Заявка принята!',
    message: 'Скоро с вами свяжется куратор',
  },
};
const PrecourseProgramCardMemo = React.memo(
  PrecourseProgramWeekCard,
  ({ isMobile: isMobilePrev }, { isMobile: isMobileCurr }) =>
    isMobileCurr === isMobilePrev,
);

export default function PrecourseProgram({
  title,
  list,
  images,
  leadData,
  metrics,
}) {
  const isSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const [isModalOpen, setIsModalOpen] = useState(false);
  const codeIconImg = (
    <GatsbyImage
      image={getImage(images['program/codeTitle'])}
      style={{ width: 24, height: 24 }}
      alt="codeIcon"
    />
  );
  return (
    <Section title={title} theme="light" bg={'precourse-program'}>
      <Box sx={{ display: 'flex', gap: { xs: 1.5, md: 4 }, flexWrap: 'wrap' }}>
        {list.map((card, index, list) => {
          const isLastCard = index === list.length - 1;
          return (
            <PrecourseProgramCardMemo
              key={card.day}
              card={card}
              isMobile={isSm}
              isLastCard={isLastCard}
              pointIcon={codeIconImg}
              image={getImage(images[`program/${card.image}`])}
            />
          );
        })}
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: { xs: 'center', md: 'flex-start' },
          mt: 4,
        }}
      >
        <Button
          variant="outlined"
          size={isSm ? 'medium' : 'large'}
          onClick={() => setIsModalOpen(true)}
        >
          хочу консультацию
        </Button>
      </Box>
      <ModalBlock
        isOpen={isModalOpen}
        handleClose={() => setIsModalOpen(false)}
      >
        <ConsultationModal
          extraLeadData={leadData}
          formData={{
            ...formData,
            // title: program,
            // subtitle: programType,
          }}
          buttonLabel="оставить заявку"
          ymSubmitEventTypes={[metrics.ym]}
          myTargetEventTypes={[metrics.mt]}
        />
      </ModalBlock>
    </Section>
  );
}
